<template>
  <footer :class="['footer',  _isMobile()?'mobile':'']">
    <div v-html="tenantInfo && tenantInfo.footer" v-if="!_isMobile()"></div>
    <div v-html="tenantInfo && tenantInfo.footerMobile" v-else></div>
  </footer>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  name: "Footer",
  mixins: [mixinDevice],
  data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
};
</script>
<style lang="less" scoped>
.mobile{
  padding-left:25px;
  padding-right:25px;
  // height: 120px!important;
}
footer {
  background: #2a56e510;
  // background: url('../assets/footer-bg.png');
  color: #999999;
  width: 100%;
  height: auto;
  min-height: 86px;
  min-height: 50px;
  bottom:0;
  // padding-top: 20px;
  padding-bottom: 15px;
  text-align: center;
}
</style>